'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import { useHighlighted } from "../context/index.js";
import { useStore } from "../internals/store/useStore.js";
export const useInteractionItemProps = skip => {
  const store = useStore();
  const {
    setHighlighted,
    clearHighlighted
  } = useHighlighted();
  if (skip) {
    return () => ({});
  }
  const getInteractionItemProps = data => {
    const onPointerDown = event => {
      if (event.currentTarget.hasPointerCapture(event.pointerId)) {
        event.currentTarget.releasePointerCapture(event.pointerId);
      }
    };
    const onPointerEnter = () => {
      store.update(prev => _extends({}, prev, {
        interaction: _extends({}, prev.interaction, {
          item: data
        })
      }));
      setHighlighted({
        seriesId: data.seriesId,
        dataIndex: data.dataIndex
      });
    };
    const onPointerLeave = event => {
      if (event.currentTarget.hasPointerCapture(event.pointerId)) {
        event.currentTarget.releasePointerCapture(event.pointerId);
      }
      store.update(prev => {
        const prevItem = prev.interaction.item;
        if (prevItem === null || Object.keys(data).some(key => data[key] !== prevItem[key])) {
          // The item is already something else, no need to clean it.
          return prev;
        }
        return _extends({}, prev, {
          interaction: _extends({}, prev.interaction, {
            item: null
          })
        });
      });
      clearHighlighted();
    };
    return {
      onPointerEnter,
      onPointerLeave,
      onPointerDown
    };
  };
  return getInteractionItemProps;
};